import {
  Box,
  Container,
  makeStyles,
  Typography,
  Paper,
  IconButton,
  Button,
  Link,
} from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { getLoginMeApiAsync, signInAsync } from './SigninStore/signinSlice';
import { isValidEmil } from '../utils/helpers';
import { GenericModalContext } from '../../components/context/GenericModalContextProvider';
import { unwrapResult } from '@reduxjs/toolkit';
import { GenericSnackBarContext } from '../../components/context/GenericSnakBarContextProvider';
import BuzzInput from '../../components/BuzzInput/BuzzInput';
import { MGMENT_DASHBOARD_ROUTE } from '../../routes/routes';

const useStyles = makeStyles({
  boxContainerStyle: {
    height: '100vh',
    width: '100%',
  },
  containerStyle: {
    height: '100%',
  },
  loginFormContainerStyle: {
    height: '100%',
    width: '100%',
  },
  paperStyle: {
    maxWidth: 578,
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1,
  },
  loginFormStyle: {
    background: 'white',
    paddingTop: 48,
    paddingBottom: 58,
    paddingInline: 40,
  },
  formStyle: {
    marginTop: 40,
  },
  underlineText: {
    cursor: 'pointer',
  },
});

const validate = (values) => {
  const errors = {};
  const { email, password } = values;

  if (!email) {
    errors.email = '**This field is required';
  } else if (!isValidEmil(email)) {
    errors.email = 'Please Enter a valid Email';
  }
  if (!password) {
    errors.password = '**This Field is required';
  } else if (password.toString().length < 5) {
    errors.password = 'Password can not be less than 5 characters';
  }

  return errors;
};

const SignInScreen = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { handleLoader } = useContext(GenericModalContext);
  const { ErrorToast } = useContext(GenericSnackBarContext);
  const { loading } = useSelector((state) => {
    const { signInReducer } = state;
    return {
      loading: signInReducer.loading,
    };
  });

  const formik = useFormik({
    initialValues: {
      showPassword: false,
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      const { email, password } = values;
      dispatch(signInAsync({ email, password }))
        .then(unwrapResult)
        .then((res) => {
          dispatch(getLoginMeApiAsync({ token: res && res.token }))
            .then((res) => {
              res &&
              res.payload &&
              res.payload.data &&
              res.payload.data.status === 'active'
                ? (window.location.href =
                    window.location.origin + MGMENT_DASHBOARD_ROUTE)
                : ErrorToast("You Don't Have The Permission!");
            })
            .catch((err) => ErrorToast("You Don't Have The Permission!"));
        })
        .catch((error) => {
          ErrorToast(error.message);
        });
    },
    validate,
  });

  const handleShowPassword = () => {
    formik.setFieldValue('showPassword', !formik.values.showPassword);
  };

  useEffect(() => {
    handleLoader(loading);
  }, [loading]);

  const { email, password } = formik.values;

  return (
    <Box className={classes.boxContainerStyle}>
      <Container className={classes.containerStyle}>
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={'center'}
          className={classes.loginFormContainerStyle}>
          <Paper elevation={5} className={classes.paperStyle}>
            <Box
              className={classes.loginFormStyle}
              display={'flex'}
              flexDirection={'column'}
              flex={1}>
              <Box display="flex" alignItems="center">
                <AcUnitIcon fontSize="large" color="primary" />
                <Typography variant="h4" color="primary">
                  <Box fontWeight={'fontWeightMedium'} ml={1}>
                    Buzz Control Center
                  </Box>
                </Typography>
              </Box>
              {/* <Box mt={3}>
                <Typography variant="h4">
                  <Box fontWeight={'fontWeightMedium'}>
                    Sign in to Buzz Platform
                  </Box>
                </Typography>
              </Box> */}
              <form
                className={classes.formStyle}
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                }}>
                <BuzzInput
                  type="email"
                  name="email"
                  required
                  placeholder="yourname@work.com"
                  label="Registered email address"
                  value={email}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  error={formik.touched.email && formik.errors.email !== ''}
                  helperText={formik.touched.email ? formik.errors.email : ''}
                />

                <Box mt={5} />
                <BuzzInput
                  required
                  value={password}
                  placeholder="Your password"
                  label="Password"
                  onChange={formik.handleChange}
                  type={formik.values.showPassword ? 'text' : 'password'}
                  name={'password'}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && formik.errors.password !== ''
                  }
                  helperText={
                    formik.touched.password ? formik.errors.password : ''
                  }
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        type="checkbox"
                        aria-label="toggle password visibility"
                        value={formik.values.showPassword}
                        onClick={handleShowPassword}>
                        {formik.values.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    ),
                  }}
                />
                <Box display="flex" flex={1} mt={1}>
                  <Box flexGrow={1} fontWeight="fontWeightMedium" />
                  <Typography className={classes.underlineText} color="primary">
                    <Link href="/forget-password">Forgotten password?</Link>
                  </Typography>
                </Box>
                <Box mt={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={formik.handleSubmit}>
                    Sign in
                  </Button>
                </Box>
              </form>
              {/* <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={1}>
                <Box fontWeight={'fontWeightMedium'}>
                  <Typography>Don't have a account?</Typography>
                </Box>

                <Box fontWeight="fontWeightMedium" ml={1}>
                  <Typography color="primary">
                    <Link href="/onboarding">Register now!</Link>
                  </Typography>
                </Box>
              </Box> */}
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default SignInScreen;
